import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { proposalService } from '../../../Services';

const List = () => {
  const [proposals, setProposals] = useState([]);
  const proposal_service = proposalService.List();
  useEffect(() => {   
    proposal_service.then(rslt => {
      return setProposals(rslt.data.proposals);
    });
  }, []);

  return (
    <>
      <section id="page-banner" className="pt-10 pb-10 bg_cover" data-overlay="8" style={{ backgroundImage: "url(../images/fellowship-programme.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-banner-cont">
                <h2>Proposals</h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    {/* <li className="breadcrumb-item"><Link to={"/"}>Home</Link></li> */}
                    <li className="breadcrumb-item active" aria-current="page">Proposals</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="pt-4 pb-50 content-min-height">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                {/* <h5>Proposals</h5> */}
                {/* <h2>Welcome to Edubin </h2> */}
              </div>
              <div className="mt-4 about-cont">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Sn.</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Registration No.</th>
                      <th className='text-center'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {proposals.map((val, key) => (
                    <tr key={key}>
                      <td>{key+1}</td>
                      <td>{val.name}</td>
                      <td>{val.email}</td>
                      <td>{val.registerNumber}</td>
                      <td className='text-center'>
                        <Link to={"/user/proposal/detail"} state={{ registerNumber: val.registerNumber, data: val.data }} title='View details' className='text-info mr-2'>
                          <FontAwesomeIcon icon={faEye} />
                        </Link>
                        {val.qpr_no ? <Link to={'/user/qpr/add/basic-information'} state={{ appid: val.id }} className="btn btn-primary btn-sm">Submit QPR</Link> : <span className="badge badge-secondary">Under review</span>}
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default List;